/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ excerpt: NonNullable<unknown> }} Notifications_Note_Added_Body_ExpandedInputs */

const en_notifications_note_added_body_expanded = /** @type {(inputs: Notifications_Note_Added_Body_ExpandedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.excerpt}`)
};

const pt_br2_notifications_note_added_body_expanded = /** @type {(inputs: Notifications_Note_Added_Body_ExpandedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.excerpt}`)
};

/**
* | output |
* | --- |
* | "{excerpt}" |
*
* @param {Notifications_Note_Added_Body_ExpandedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_note_added_body_expanded = /** @type {((inputs: Notifications_Note_Added_Body_ExpandedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Note_Added_Body_ExpandedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_note_added_body_expanded(inputs)
	return pt_br2_notifications_note_added_body_expanded(inputs)
});